<template>
  <div>
    <component :is="selectedUserGroupComponent" v-bind="currentProperties"
    @changeSelectedComponent="changeSelectedComponent" :seletedUserGroupName="selectedUserGroupInfo.group_name"></component>
  </div>
</template>

<script>

import AddUserGroup from "./AddUserGroup.vue"
import ShowUsersGroup from "./ShowUserGroups.vue"
import UserGroupInfo from "./UserGroupInfo.vue"

export default {
  name: "UserGroups",
  data() {
    return {
      selectedUserGroupComponent: ShowUsersGroup,
      selectedUserGroupInfo: {},
    };
  },
  components: {
    "add-user-group": AddUserGroup,
    "user-group-info": UserGroupInfo,
    "show-user-groups": ShowUsersGroup,
  },
  methods: {
    changeSelectedComponent(compName, userGroupInfo = {}) {
      this.selectedUserGroupComponent = compName;
      this.selectedUserGroupInfo = userGroupInfo;
      if(typeof userGroupInfo != "undefined"){
      this.$emit('updateGroupNavBarComponent', (compName != 'add-user-group') ,userGroupInfo.group_name,compName)
      }
      else{
        this.$emit('updateGroupNavBarComponent',(compName != 'add-user-group'),"")
      }
    },
    showBinsTopNav() {
      let comps = [
        "add-user-group",
        "user-group-info",
        "user-group-privileges",
        "user-group-bins-permissions",
        "user-group-catalog-permissions"
      ];
      if (comps.indexOf(this.selectedUserGroupComponent) > -1) {
        return true;
      }
    }
  },
  computed:{
    currentProperties() {  
      if (this.selectedUserGroupComponent === "user-group-info" ||
      this.selectedUserGroupComponent === "user-group-bins-permissions" ) {
        return { selectedUserGroupID: this.selectedUserGroupInfo._id };
      }else{
        return {}
      }
    },
  },
};
</script>

<style scoped>

</style>